export default "Byg jeres egne simple trækbårer af grene og snor – brug dem fx til en trækbåre-stafet!";